import { render } from "./EditAccount.vue?vue&type=template&id=c8256bfc&scoped=true"
import script from "./EditAccount.vue?vue&type=script&lang=js"
export * from "./EditAccount.vue?vue&type=script&lang=js"

import "./EditAccount.vue?vue&type=style&index=0&id=c8256bfc&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8256bfc"]])

export default __exports__